import type { DependencyList } from "react";
import type { UseEditorOptions } from "@tiptap/react";
import { Editor, useEditor } from "@tiptap/react";
import { cn } from "@acdc2/ui/lib/utils";

type Props = {
  options?: UseEditorOptions;
  deps?: DependencyList;
};

export function useRichTextEditor({ options, deps }: Props): Editor | null {
  const attributes = options?.editorProps?.attributes ?? {};

  const editor = useEditor(
    {
      ...options,
      editorProps: {
        ...options?.editorProps,
        attributes: {
          ...options?.editorProps?.attributes,
          class: cn(
            "min-h-[60px] w-full border-input bg-transparent px-3 py-2 text-base shadow-xs placeholder:text-muted-foreground focus-visible:outline-hidden focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm break-all",
            "class" in attributes && attributes.class,
          ),
        },
      },
    },
    deps,
  );

  return editor;
}
